module.exports = __webpack_public_path__ + "img/iconMap.f9329793.png";